import notification from '../../notification';

const activeErrorMessages = new Set<string>();

export const showGeneralErrorNotification = (
  message: React.ReactNode,
  header = 'Oops!',
) => {
  const messageKey = typeof message === 'string' ? message : String(message);

  if (activeErrorMessages.has(messageKey)) {
    return;
  }

  activeErrorMessages.add(messageKey);

  notification.error({
    header,
    content: message,
    onClose: () => {
      activeErrorMessages.delete(messageKey);
    },
  });
};
